var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestNodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#137FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 12H10.667",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 9.33203H10.667",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 15.3333V7.33333C16.667 6.97971 16.5265 6.64057 16.2765 6.39052C16.0264 6.14048 15.6873 6 15.3337 6H6.66699",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 18H17.333C17.6866 18 18.0258 17.8595 18.2758 17.6095C18.5259 17.3594 18.6663 17.0203 18.6663 16.6667V16C18.6663 15.8232 18.5961 15.6536 18.4711 15.5286C18.3461 15.4036 18.1765 15.3333 17.9997 15.3333H11.333C11.1562 15.3333 10.9866 15.4036 10.8616 15.5286C10.7366 15.6536 10.6663 15.8232 10.6663 16V16.6667C10.6663 17.0203 10.5259 17.3594 10.2758 17.6095C10.0258 17.8595 9.68663 18 9.33301 18ZM9.33301 18C8.97939 18 8.64025 17.8595 8.3902 17.6095C8.14015 17.3594 7.99967 17.0203 7.99967 16.6667V7.33333C7.99967 6.97971 7.8592 6.64057 7.60915 6.39052C7.3591 6.14048 7.01996 6 6.66634 6C6.31272 6 5.97358 6.14048 5.72353 6.39052C5.47348 6.64057 5.33301 6.97971 5.33301 7.33333V8.66667C5.33301 8.84348 5.40325 9.01305 5.52827 9.13807C5.65329 9.2631 5.82286 9.33333 5.99967 9.33333H7.99967",
    stroke: "#EEF9FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestNodeIcon);
export default __webpack_public_path__ + "static/media/digestNodeIcon.6dd65adec649ef43b5e653a6d4911b4f.svg";
export { ForwardRef as ReactComponent };